import AxiosHttpFactory from '@/features/api/axiosHttpFactory'
import { ErrorTransformInterceptor } from '@/features/api/errorTransformInterceptor'
import { MissingNetworkConnectionInterceptor } from '@/features/api/missingNetworkConnectionInterceptor'
import { OAuthErrorTypeEnum } from '@/features/api/oauth/constants'
import { IApiTokenResponse, IOAuthAPI, ITokenResponse } from '@/features/api/oauth/types'
import { AxiosError } from 'axios'
import { ownerCredentials, refreshToken as refresh } from 'axios-oauth-client'
import invariant from 'tiny-invariant'

class OAuthAPI implements IOAuthAPI {
    private $oauth = AxiosHttpFactory.createMultiClient({
        extras: {
            errorIdentifier: (error: AxiosError<{ error: OAuthErrorTypeEnum }>) =>
                error.response?.data.error,
        },
    })

    constructor() {
        new MissingNetworkConnectionInterceptor(this.$oauth)

        new ErrorTransformInterceptor(this.$oauth)
    }

    setHostUrl(url: string) {
        this.$oauth.defaults.baseURL = url
    }

    private transformTokens(tokens: IApiTokenResponse): ITokenResponse {
        return {
            accessToken: tokens.access_token,
            refreshToken: tokens.refresh_token,
            expiresIn: tokens.expires_in,
        }
    }

    async fetchTokens(clientId: string, clientSecret: string, username: string, password: string) {
        invariant(this.$oauth.defaults.baseURL, 'Host url must be set')

        const request = ownerCredentials(this.$oauth, '/oauth2/token', clientId, clientSecret)

        const tokens = await request(username, password, 'terminal')

        return this.transformTokens(tokens)
    }

    async refreshTokens(clientId: string, clientSecret: string, refreshToken: string) {
        invariant(this.$oauth.defaults.baseURL, 'Host url must be set')

        const request = refresh(this.$oauth, '/oauth2/token', clientId, clientSecret)

        const tokens = await request(refreshToken, 'terminal')

        return this.transformTokens(tokens)
    }
}

export default new OAuthAPI()
